import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	snippetCardAriaLabel: {
		id: 'snippets.panel.item.card.aria-label',
		defaultMessage: 'Block Template: {name}',
		description:
			'The text is used as the accessible aria-label for a block template card button in the snippet panel. The placeholder {name} will be substituted with the name of the block template (e.g., "Meeting Notes").',
	},
	snippetPreview: {
		id: 'snippets.panel.item.preview',
		defaultMessage: 'Preview',
		description: 'Text shown in the preview area of a block template card',
	},
});
